export enum InvoiceItemEditType {
    Form = 'edit',
    Grid = 'grid-edit',
    New = 'new-item',
}
